export function nameToLeadingCharacters(name: string) {
    return name[0];
}
